var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#303030;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m149.24,136.18L80.61,7.83c-1.65-3.1-5.51-4.27-8.61-2.61-1.11.59-2.02,1.5-2.61,2.61L.76,136.18c-1.65,3.1-.48,6.95,2.62,8.6.92.49,1.94.75,2.99.75h137.26c3.51,0,6.36-2.85,6.36-6.36,0-1.04-.26-2.07-.75-2.99Zm-74.24-14.02c-4.02,0-7.28-3.26-7.28-7.28,0-4.02,3.26-7.28,7.28-7.28,4.02,0,7.28,3.26,7.28,7.28,0,0,0,0,0,0,0,4.02-3.26,7.27-7.28,7.27Zm7.44-68.68c0,1.28,0,3.11-.08,5.31s-.06,4.76-.21,7.5-.21,5.67-.46,8.6c-.36,5.86-1,11.71-1.59,16.1s-1.2,7.32-1.2,7.32c-.49,2.15-2.63,3.5-4.79,3.01-1.5-.34-2.67-1.51-3.01-3.01,0,0-.6-2.92-1.2-7.32s-1.23-10.24-1.59-16.1c-.25-2.89-.31-5.89-.46-8.6s-.2-5.31-.21-7.5-.06-4-.08-5.31c-.03-.5-.03-.99,0-1.49.62-.22,1.28-.36,1.94-.39l1.59-.13c2.6-.21,5.2-.21,7.8,0l1.59.13c.66.03,1.32.17,1.94.39.04.5.04.99.02,1.49Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.363a20f5a217d1eddced87c26a157967.svg";
export { ForwardRef as ReactComponent };